/**
 * Accordion Block
 *
 * UI for handling the logic and animations of accordion block
 */

const $ = require( 'jquery' );

var itblAccordion = function(el){

  //setup some variables
  this.$el      = $(el);
  this.$toggle    = this.$el.find('.js-accordion-toggle');

  this.init();
};

itblAccordion.prototype.init = function(){

  this.events();

};

itblAccordion.prototype.events = function(){
  this.$toggle.on('click', this.event__handleOpenCard.bind(this));
};

itblAccordion.prototype.event__handleOpenCard = function(event){
  event.preventDefault();
  
  if(!$(event.currentTarget).hasClass('is-active')) {
    $('.itbl-c-accordion__content').hide("fast");

    let el     = event.currentTarget.getAttribute('data-card');
    let img    = event.currentTarget.getAttribute('data-img-src');

    $('.js-accordion-toggle.is-active').removeClass('is-active');

    $(el + '__title').addClass('is-active');
    $(el + '__link').addClass('is-active');
    
    $(el + ' > .itbl-c-accordion__content').show('fast');
    $('.js-accordion-image').attr('src', img);
  }
}

$(document).ready(function(){
  $('.itbl-c-accordion-new').each(function(){
    new itblAccordion(this);
  });
});
